import React from "react";

import { IToast } from "shared/components/Toast/types";
import { getStatus } from "shared/styles/defaults";
import { slideInFromTop } from "shared/styles/constants";
import { Icon } from "shared/styles";
import { Spacer } from "shared/layout";

import { ToastContainer, ToastIcon, ToastMessage } from "./styles";

export const Toast: React.FC<IToast> = ({ status, message }) => {
  const { icon } = getStatus(status);

  return (
    <ToastContainer {...slideInFromTop} data-testid={`${status}_toast`}>
      <Spacer size="xs" spaceDirection="horizontal" align="center">
        {icon && (
          <ToastIcon status={status}>
            <Icon as={icon} />
          </ToastIcon>
        )}
        <ToastMessage>{message}</ToastMessage>
      </Spacer>
    </ToastContainer>
  );
};
